import React from 'react';
import Hampi2025 from 'views/Hampi2025';


const MathClubPage = () => {
  return <Hampi2025/>;
};

export default MathClubPage;

